export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/array.js
// module id = 1771
// module chunks = 0